<template>
  <div
    class="site"
    :class="{ debug: debug }"
    data-test-id="signage-site"
    @click="$router.push('/')"
  >
    <warning-message
      v-if="!site.loaded"
      is-loading-message
    >
      {{ $t('status.loading') }}
    </warning-message>
    <div v-else-if="site">
      <warning-message
        v-if="movies.length == 0"
      >
        {{ $t('showing.noShowingsToday') }}
      </warning-message>
      <!-- We have a showtimes-->
      <div
        class="main-display"
        :style="{
          top: marginVertical + 'px ',
          bottom: marginVertical + 'px ',
          left: +marginHorizontal + 'px',
          right: +marginHorizontal + 'px'
        }"
      >
        <div
          v-if="showLogo"
          style="height: 8vh;padding: 1.5vh;"
        >
          <img
            class="site-logo"

            :src="site.lightLogoImageUrl"
            :style="$isLandscapeView() ? 'height: 5vh' : 'width: 30vw'"
          >
          <div class="time text-uppercase">
            {{ site.siteTime.format("h:mm a") }}
          </div>
        </div>
        <div class="wrapper">
          <swiper
            :key="changeCount"
            :modules="[Pagination, Autoplay]"
            :pagination="{ el: '.swiper-pagination' }"
            :autoplay="signageAutoplay"
            :slides-per-view="moviesPerPage"
            :slides-per-group="pageMode ? moviesPerPage : 1"
            :space-between="30"
            :loop="hasMultiSlides"
            preload-images
            class="swiper"
          >
            <swiper-slide
              v-for="(showings, movieId) in movies"
              :key="movieId"
            >
              <div
                class="column justify-between"
                style="padding-left: 0.4vw; padding-right: 0.4vw;"
                :style="{ height: showLogo ? '92vh' : '100vh' }"
              >
                <div
                  class="col"
                >
                  <div
                    class="movie relative-position"
                    :class="$isLandscapeView() && moviesPerPage < 4 ? 'text-center' : 'text-left'"
                  >
                    <explore-poster
                      :movie="showings[0].movie"
                      :clean-image-on-posters="cleanImage"
                      show-movie-title-on-posters
                      show-movie-rating
                      is-font-size-responsive
                      display-rating-reason
                      explore-using-dark-mode
                      is-inside-swiper
                      poster-background-color="custom"
                      poster-background-color-hex="#00000000"
                      :image-max-width=" $isLandscapeView() && moviesPerPage < 4 ? '20vw' : null"
                      :has-text-wrapped="false"
                      :show-user-buttons="false"
                      :font-size="1.7"
                      :has-text-centred="false"
                      :highlight-r-rated="highlightRRated"
                      :disable-official-symbol="disableOfficialSymbol"
                    />
                  </div>
                  <div
                    class="showings"
                    :style="`border-top: 0.5vh solid ${site.primaryColor};`"
                    style="margin-top: 0.5vh; padding: 1vh 0;"
                  >
                    <div
                      class="items-start"
                      :class="isDueShowingsPreRow ? 'row inline-block justify-starts' : 'column justify-start'"
                    >
                      <q-chip
                        v-for="(showing, index) in showings"
                        :key="showing.id"
                        class="text-uppercase text-left overflow-hidden"
                        :color="displayShowingBadges ? 'white' : showing.current && isDueShowingsPreRow ? 'grey-9' : 'transparent'"
                        :text-color="showing.current || showing.past ? '' : 'white'"
                        square
                        dense
                        :outline="displayShowingBadges"
                        style="margin: 0.5vw 0; border-radius: 0; padding: 0;"
                        :style="styleForShowing(showing, index, showings)"
                      >
                        <div class="row full-width justify-between items-center self-center text-center text-bold">
                          <span class="col">{{ showing.siteTime.format("h:mm a") }}</span>
                          <showing-badges
                            v-if="displayShowingBadges"
                            :showing="showing"
                            :color="showing.current ? 'grey-4' : 'white'"
                            :current="showing.current"
                            :size="$isLandscapeView() ? '1.5vw' : '1.8vh'"
                            class="col"
                            style="border-left: 0.1vw solid;"
                            :style="$isLandscapeView() ? 'height:3.5vw; margin: 0.5vw 0' : 'height: 3.5vh;'"
                          />
                        </div>
                      </q-chip>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>

            <div
              class="swiper-pagination text-white"
            />
          </swiper>
        </div>
      </div>
    </div>
    <warning-message
      v-else-if="errorOccurred"
    >
      A network error occurred
    </warning-message>
    <warning-message
      v-else
    >
      Unknown Error
    </warning-message>
  </div>
</template>

<script>
import ExplorePoster from 'src/modules/consumer/components/ExplorePoster'
import SwiperModulesMixin from 'src/modules/consumer/components/mixins/SwiperModulesMixin'
import ShowingBadges from 'src/modules/signage/components/ShowingBadges'
import WarningMessage from 'src/modules/signage/components/WarningMessage'
import ShowingsSignageConfigurationMixin from 'src/modules/signage/mixins/ShowingsSignageConfigurationMixin'
import { inject } from 'vue'

export default {
  name: 'ShowingsPoster',
  components: {
    ExplorePoster,
    WarningMessage,
    ShowingBadges

  },
  mixins: [ShowingsSignageConfigurationMixin, SwiperModulesMixin],
  models: {
    site: {
      fields: ['id', 'name', 'primaryColor', 'lightLogoImage', 'timeZone', 'signageConfig', 'migratedTo'],
      todaysShowings: {
        movie: 'default',
        screen: 'default',
        showingBadges: 'default'
      },
      variables () {
        return {
          id: this.siteId
        }
      },
      immediate: true
    }
  },
  props: {
    overrideSiteId: {
      type: Number,
      required: false,
      default: null
    },
    overrideCover: {
      type: Boolean,
      required: false,
      default: false
    },
    interval: {
      type: Number,
      required: false,
      default () {
        const route = inject('route')
        return parseInt(route?.query?.interval) || 5000
      }
    },
    pageMode: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return route?.query?.mode === 'page'
      }
    },
    moviesPerPage: {
      type: Number,
      required: false,
      default () {
        const route = inject('route')
        return (route?.query && parseInt(route.query['movies-per-page'])) || 4
      }
    },
    cleanImage: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return (route?.query && route.query['clean-image'] === 'true')
      }
    },
    displayShowingBadges: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return (route?.query && route.query['display-showing-badges'] === 'true') || false
      }
    }
  },
  data () {
    return {
      errorOccurred: false,
      changeCount: 0
    }
  },
  computed: {
    titleClassIds () {
      if (!this.$route.query['title-class-ids']) return

      return _.map(this.$route.query['title-class-ids'].split(','), parseInt)
    },
    hidePast () {
      return this.$route.query['hide-past'] === 'true'
    },
    movies () {
      if (!this.site) return

      return _(this.site.todaysShowings.data)
        .filter(showing => !this.titleClassIds || _.includes(this.titleClassIds, showing.movie.titleClassId))
        .filter(showing => !this.hidePast || !showing.past)
        .groupBy('movie.id')
        .sortBy(showings => -showings.length) // Second priority is number of showings
        .sortBy(showings => showings[0].screen.displayOrder) // First priority is what screen it is in
        .value()
    },
    marginVertical () {
      return this.overrideMarginVertical || this.$route.query['margin-vertical'] || 0
    },
    marginHorizontal () {
      return this.overrideMarginHorizontal || this.$route.query['margin-horizontal'] || 0
    },
    debug () {
      return this.overrideDebug || this.$route.query.debug || false
    },
    cover () {
      return this.overrideCover || this.$route.query.cover || false
    },
    siteId () {
      return this.overrideSiteId || this.$route.params?.siteId
    },

    isDueShowingsPreRow () {
      return this.$isLandscapeView() && this.moviesPerPage < 5 && !this.displayShowingBadges
    },
    hasMultiSlides () {
      return this.movies.length > this.moviesPerPage
    }
  },
  async mounted () {
    this.moviesIntervalId = setInterval(() => {
      this.site.fetch(true)
    }, 10 * 60 * 1000)

    await this.site.fetch()

    if (this.$signage) {
      // Fetching the site when in the app mode of digital-signage, sets the site_id cookie
      // This will reload the configuration data after being authenticated
      this.$handleAuthChange()
    }
  },
  beforeUnmount () {
    if (this.timeIntervalId) clearInterval(this.timeIntervalId)

    if (this.moviesIntervalId) clearInterval(this.moviesIntervalId)
  },
  methods: {
    styleForShowing (showing, index, showings) {
      const style = []

      if (showing.past) style.push('text-decoration: line-through; ' + 'color: ' + this.$lightenColor(this.site.primaryColor, 20))
      if (showing.current) style.push('color: ' + this.$lightenColor(this.site.primaryColor, 80))
      if (showing.current && !this.isDueShowingsPreRow) style.push('border: 0.3vw solid' + this.$lightenColor(this.site.primaryColor, 30))
      if (this.$isLandscapeView()) {
        style.push('font-size: 2vw')
        if (!this.isDueShowingsPreRow) {
          style.push('width: 99%')
        } else if (this.moviesPerPage < 3) {
          style.push('width: 30%')
          if (showings.length > 1 && ((index + 1) % 3)) style.push('border-right: 0.2vw solid' + this.$lightenColor(this.site.primaryColor, 20))
          return style.join(';')
        } else if (this.moviesPerPage < 5) {
          style.push('width: 45%')
          if (showings.length > 1 && (index % 2 === 0)) style.push('border-right: 0.2vw solid' + this.$lightenColor(this.site.primaryColor, 20))
          return style.join(';')
        }

        return style.join(';')
      } else {
        style.push('font-size: 2vh')
        if (showings.length > 1) {
          style.push('width: 50%')
        } else {
          style.push('width: 100%')
        }
      }
      return style.join(';')
    }
  }
}
</script>

<style scoped>
.site {
  background-color: #161616;
  color: #fff;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.site.debug {
  border: solid 1px red;
}
.main-display {
  position: absolute;
  display: flex;
  flex-direction: column;
}
.time {
  position: absolute;
  top: 1vh;
  right: 1vh;
  font-size: 3vh;
}
.swiper-slide:nth-child(even) {
  background-color: #101010;
}
.swiper-slide:nth-child(odd) {
  background-color: #191919;
}
.showings {
  flex-grow: 3;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
</style>
